var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigureList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 528,
    height: 432,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M264 432c145.7 0 263.7-61 263.7-136.1 0-75.2-118-136.1-263.7-136.1S.3 220.8.3 295.8C.3 371 118.3 432 264 432Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#72204D",
    d: "m275.2 337.5-18-33.9 14.5-41.8v-25.6l-44.4 25.6v25.6l19.1 33c.3.6.8 1 1.3 1.2l27.5 16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m275.2 337.5-18-33.9 14.5-41.8v-25.6l-44.4 25.6v25.6l19.1 33c.3.6.8 1 1.3 1.2l27.5 16Z",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#72204D",
    d: "M381.2 32.6a29.2 29.2 0 0 0-13.4-23L357 3.1a29.4 29.4 0 0 0-26.6 0l-166 96.1a29.4 29.4 0 0 0-13.4 23V305a29.4 29.4 0 0 0 13.3 23l10.8 6.3a29.4 29.4 0 0 0 26.6 0l53.5-31 19 33a2.9 2.9 0 0 0 5-.4l20-58 68.4-39.7a29.3 29.3 0 0 0 13.3-23l.3-182.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151 305a29.4 29.4 0 0 0 13.3 23l10.8 6.3a30 30 0 0 0 24.4 1c-6.3 2.4-11-1.1-11-8.7V144c.1-4.6 1.5-9.2 3.9-13.1l-37.5-21.6c-2.4 4-3.7 8.5-3.9 13V305Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M380.7 28.8c-1.5-5.7-6.7-7.5-12.8-4L201.7 121c-3.9 2.4-7.1 5.9-9.3 10l-37.5-21.6c2.3-4 5.5-7.5 9.4-10l166-96.1a29.4 29.4 0 0 1 26.7 0l10.9 6.2a29.4 29.4 0 0 1 12.8 19.3Z",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M340.1 76a15.3 15.3 0 0 0-20 8.1l-57.7 137.3-13.7-13.3a15.3 15.3 0 1 0-21.3 22l30 29a15 15 0 0 0 13.7 4 15 15 0 0 0 11-9.1l66.4-158a15.3 15.3 0 0 0-8.4-20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureList);
export default __webpack_public_path__ + "static/media/configure_list.07e05c854b9b7e628aa3026018ba9d94.svg";
export { ForwardRef as ReactComponent };